// SlackLinkApi — the interaction-gateway per-user link call (canonical api/ contract 03 §15).
// Takes its http instance by constructor injection and returns the unwrapped DTO, never an
// AxiosResponse.
//
// The path carries the FULL gateway prefix on purpose. `appHttp` is based at the Django root, and
// the gateway mounts under `/api/interaction-gateway/v1/` — a bare `/slack/link/complete` 404s.
// That exact omission shipped to production in the legacy frontend and made the whole flow
// unusable (ORP-19716); the backend path is not going to move, so this is pinned by a test.
import type { AxiosInstance } from 'axios'

import type { SlackLinkCompletion } from '../models/slackLink.types'

import { appHttp, unwrap } from '@/shared/http'

export const SLACK_LINK_COMPLETE_PATH = '/api/interaction-gateway/v1/slack/link/complete'

export class SlackLinkApi {
  // Injectable for tests; defaults to the singleton instance.
  constructor(private readonly http: AxiosInstance = appHttp) {}

  /**
   * POST slack/link/complete — redeems the one-time code against the caller's session.
   *
   * The code is the ONLY field sent. The backend reads nothing else (`link.py` `_parse_link_code`),
   * so the workspace picker the legacy page rendered decided nothing — the link binds to the
   * installation's own workspace snapshot. Sending a preference here would be theatre.
   */
  async complete(code: string): Promise<SlackLinkCompletion> {
    return unwrap(await this.http.post<SlackLinkCompletion>(SLACK_LINK_COMPLETE_PATH, { code }))
  }
}
